export enum AuthenticationFailedTypes {
	Failed = 'failed',
	Invalid = 'invalid',
	ThreshholdExceeded = 'threshholdExceeded'
}
